/**
 * Size of the companion corner, shared by the React view and the puzzle
 * layouts: the bust sits in a strip at the bottom of the puzzle screen, and
 * scenes keep their pieces above that strip so it never covers them.
 */
export const COMPANION_GAP = 8;

/** Room above the bust for hats, as a fraction of its height: at least this, more for tall headwear. */
export const COMPANION_HEADROOM = 0.12;
export const COMPANION_HEADROOM_MAX = 0.45;

/** Bust height in CSS px for a viewport height (smaller on short phones). */
export function companionHeight(viewportHeight: number): number {
  return viewportHeight < 700 ? 80 : 100;
}

/** Most space a puzzle layout keeps free at the bottom (CSS px, before the safe area): the tallest hat. */
export function companionInset(viewportHeight: number): number {
  return Math.ceil(companionHeight(viewportHeight) * (1 + COMPANION_HEADROOM_MAX)) + COMPANION_GAP * 2;
}
